import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../.services/settings.service';
import { ConnectionService } from '../.services/connection.service';



declare var SoundMeter: any;
declare var window: any;



@Component({
  selector: 'app-audio-only',
  templateUrl: './audio-only.component.html',
  styleUrls: ['./audio-only.component.css']
})

export class AudioOnlyComponent implements OnInit {



    settings:any;
    connection:any;
    videoStreams: any;
    navigator: any;
    visualizers: any = [];
    visualizerWaterFallList: any = [];
    counter: any = 0;
    active: boolean = true;
    
    

  constructor(private settingsService: SettingsService, private connectionService: ConnectionService) {        
      this.settings = settingsService;
      this.connection = connectionService;
      this.videoStreams = this.connection.streamList;

     // navigator.mediaDevices.getUserMedia(this.constraints).then(this.handleSuccess).catch(this.handleError);
  }



  
  addToWaterfall = (user) => {
    let find = this.visualizerWaterFallList.find(x => {
      return x.id == user.id
    })
    if(find) {
      find.time = Date.now();
    } else {
      this.visualizerWaterFallList.unshift({id: user.id, name: user.username, time: Date.now()}) 
    }
  }

  createVisualizer = (stream, user) => {
    //check for dead visualizers
    let newMeter = new SoundMeter(window.audioContext);
      newMeter.connectToSource(stream, (e) => {
        if (e) {
          console.log('SoundMeter Error: ' + e)
          return;
        }
       let loop = setInterval(() => {
          let instant = newMeter.instant.toFixed(2); //instant
          if(instant > 0) {
            this.addToWaterfall(user);
          }
        }, 200);  
        this.visualizers.push({interval: loop, user: user, lastActive:  Date.now()});     
      });
  }

  startWaterFallCounter = () => {
    setInterval(() => {
      if(this.active){
        for(let i=0; i < this.visualizerWaterFallList.length; i++){
          if(Date.now() - this.visualizerWaterFallList[i].time  > 2000) {
            this.visualizerWaterFallList.splice(i, 1);
          }
        }
      }
    }, 1000)
  }

  spinUpVisualizers = () => {

    let streams = this.connection.connection.streamEvents;
    let usersList = this.connection.users;


    setTimeout(()=>{
      for(let stream in streams) {
        if(streams[stream].stream) {
          let user = usersList.find(x => {
            return x.streamId == stream;
          })
          if(user) {
            this.createVisualizer(streams[stream].stream, user);
          }  
        }
      }

      this.counter = this.startWaterFallCounter(); 

    }, 3000)


  }

  handleError(error) {
    console.log('navigator.getUserMedia error: ', error);
  }





  ngOnInit() {

    try {
      window.AudioContext = window.AudioContext || window.webkitAudioContext;
      window.audioContext = new AudioContext();
      //this.spinUpVisualizers();
    } catch (e) {
      console.log('Web Audio API not supported.');
    }

    this.connection.userCast.subscribe((user) => {
      this.spinUpVisualizers();
    })

  }
}
